import $ from 'jquery';
import ko from 'knockout';
import wishList from '../productclasspage/wishlist.js';

function BlanketQuiz(obj) {
    this.questions = obj;
    this.currentQuestion = ko.observable(this.questions[0]);
    this.currentProducts = ko.observable();
    this.history = ko.observableArray();

    this.updateState = function (answer) {
        this.history.push(answer);
        return true;
    }.bind(this);

    this.updateStateFromHistory = function (answer) {
        var historyIndex;
        this.history().forEach(function (historyItem, index) {
            if (answer.response === historyItem.response) {
                historyIndex = index;
            }
        });
        this.history(this.history.slice(0, historyIndex + 1));
        return true;
    }.bind(this);

    this.addProductsToCurrentQuestion = function (question) {
        if (question.products) {
            var newProductIds = question.products.map(function (product) {
                return product - 10000;
            });
            smartPak.api.product.getProductClassDTOList(newProductIds).done(
                function (data) {
                    if (data.length) {
                        this.currentProducts(data);
                        smartPak.recentlyViewedProducts.loadBvReviewStars('.quizReviewStars');
                    }
                }.bind(this)
            );
        }
    }.bind(this);

    this.findCurrentQuestion = function (hash) {
        var question, questionMatch;
        if (hash === '') {
            question = this.questions[0];
        } else {
            questionMatch = this.questions.filter(function (question) {
                return question.name === hash;
            });
            question = questionMatch[0];
        }
        return question;
    }.bind(this);

    this.addToWishList = function (product, event) {
        wishList._addToWishList($(event.currentTarget));
    };

    $(window).on(
        'popstate',
        function () {
            var question = this.findCurrentQuestion(window.location.hash.substr(1));
            this.currentProducts([]);
            this.currentQuestion(question);
            this.addProductsToCurrentQuestion(question);
        }.bind(this)
    );
}

export default BlanketQuiz;
